<template>
  <section class="px-14 md-max:pt-0 sm-max:px-5 mt-24 text-center sm:pb-10 sm-max:mt-6">
    <div class="border-b-[5px] border-gray m-5"></div>
    <nuxt-img
        class="m-auto pt-8"
        width="312"
        height="103"
        loading="lazy"
        :alt="logoAlt"
        format="webp"
        :src="logoSrc"
    ></nuxt-img>
    <div class="text-center mt-8 border-[3px] border-1 border-footerHover inline-block transition-all duration-300 ease-linear hover:bg-footerHover hover:text-white">
      <a :href="`tel:${contactNumber}`" class="py-4 px-10 sm-max:px-4 sm-max:py-2 inline-block">
        <span class="md:text-base text-15"> {{ helpText }} </span> <br><span class="md:text-34 text-22">{{ contactNumber }}</span>
      </a>
    </div>
    <div class="flex items-center justify-center mt-9 gap-10 md-max:gap-4 sm-max:inline-grid">
      <div class="flex items-center justify-center">
        <nuxt-img
            class="w-6 h-6"
            loading="lazy"
            :alt="chatAlt"
            format="webp"
            :src="chatIconSrc"
        ></nuxt-img>
        <span class="ml-1 sm-max:text-15 text-base uppercase"> {{ chatText }}</span>
      </div>
      <a class="flex items-center justify-center" :href="`mailto:${email}`">
        <span class="sm-max:text-15 text-base uppercase">
            <svg class="h-6 w-6 relative sm:top-0 mr-1 inline-block" x-description="Heroicon name: outline/mail"
                 xmlns="http://www.w3.org/2000/svg"
                 fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
        </svg> email: {{ email }}
        </span>
      </a>
    </div>
    <div class="flex justify-center sm-max:gap-0 gap-4 text-base sm-max:mt-6 mt-28 md-max:inline-grid">
      © {{ new Date().getFullYear() }} {{ companyName }}. All Rights Reserved. <a :href="termsLink" target="_blank">{{ termsText }}</a> <a :href="privacyLink" target="_blank">{{ privacyText }}</a>
    </div>
  </section>
</template>

<script setup>

defineProps({
  logoSrc: {
    type: String,
    default: '/assets/images/black-logo.svg'
  },
  logoAlt: {
    type: String,
    default: 'logo-lifeboost'
  },
  helpText: {
    type: String,
    default: 'QUESTIONS? LET US HELP YOU:'
  },
  contactNumber: {
    type: String,
    default: '1-800-479-1596'
  },
  chatIconSrc: {
    type: String,
    default: '/assets/images/icon-chat.png'
  },
  chatAlt: {
    type: String,
    default: 'chat'
  },
  chatText: {
    type: String,
    default: 'live chat'
  },
  email: {
    type: String,
    default: 'support@lifeboostcoffee.com'
  },
  companyName: {
    type: String,
    default: 'Lifeboost Coffee'
  },
  termsLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/terms-conditions'
  },
  termsText: {
    type: String,
    default: 'Terms and Conditions'
  },
  privacyLink: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/privacy-policy'
  },
  privacyText: {
    type: String,
    default: 'Privacy Policy'
  }
})

defineBuilderComponent({
    friendlyName: "Footer",
    canHaveChildren: true,
    inputs: [
        {
            name: "logoSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/black-logo.svg"
        },
        {
            name: "logoAlt",
            type: "string",
            defaultValue: "logo-lifeboost"
        },
        {
            name: "helpText",
            type: "string",
            defaultValue: "QUESTIONS? LET US HELP YOU:"
        },
        {
            name: "contactNumber",
            type: "string",
            defaultValue: "1-800-479-1596"
        },
        {
            name: "chatIconSrc",
            type: "file",
            allowedFileTypes: [
                "jpeg",
                "jpg",
                "svg",
                "png"
            ],
            required: true,
            defaultValue: "/assets/images/icon-chat.png"
        },
        {
            name: "chatAlt",
            type: "string",
            defaultValue: "chat"
        },
        {
            name: "chatText",
            type: "string",
            defaultValue: "live chat"
        },
        {
            name: "email",
            type: "string",
            defaultValue: "support@lifeboostcoffee.com"
        },
        {
            name: "companyName",
            type: "string",
            defaultValue: "Lifeboost Coffee"
        },
        {
            name: "termsLink",
            type: "string",
            defaultValue: "https://lifeboostcoffee.com/pages/terms-conditions"
        },
        {
            name: "termsText",
            type: "string",
            defaultValue: "Terms and Conditions"
        },
        {
            name: "privacyLink",
            type: "string",
            defaultValue: "https://lifeboostcoffee.com/pages/privacy-policy"
        },
        {
            name: "privacyText",
            type: "string",
            defaultValue: "Privacy Policy"
        }
    ]
});
</script>